import { render } from "./Account.vue?vue&type=template&id=506fedea&scoped=true"
import script from "./Account.vue?vue&type=script&lang=js"
export * from "./Account.vue?vue&type=script&lang=js"

import "./Account.vue?vue&type=style&index=0&id=506fedea&lang=less&scoped=true"

import exportComponent from "D:\\Project\\远创人力\\开发\\前端\\yc_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-506fedea"]])

export default __exports__